import {
  api_newsletter_details_path,
  api_newsletter_subscribe_path,
  api_newsletter_subscription_status_path,
  api_newsletter_unsubscribe_path,
  api_newsletters_path,
  api_subscribe_to_all_newsletters_path,
} from '@routes';

import { getJWT } from '../jwtHelper';
import request from './request';

export const NEWSLETTER_SUBSCRIPTION_KEY = 'NEWSLETTER_SUBSCRIPTION_KEY';
export const NEWSLETTER_SUBSCRIPTIONS_KEY = 'NEWSLETTER_SUBSCRIPTIONS_KEY';
export const NEWSLETTERS_KEY = 'NEWSLETTERS_KEY';

export interface NewsletterSubscriptionStatus {
  isSubscribed: boolean;
}

export interface NewsletterSubscriptionParams {
  newsletter_id: number | string;
}

export interface NewsletterSubscription {
  accessLevel: number;
  author: string;
  frequency: string;
  isPro: boolean;
  isSubscribed: boolean;
  newsletterId: number;
  offerCode?: string;
  slug: string;
  subheader: string;
  title: string;
}

export interface Newsletter {
  accessLevel: number;
  afterSignUpUrl: string;
  author: string;
  cardImageUrl: string;
  currentUserSubscribed: boolean;
  description: string;
  frequency: string;
  hasPublishedArticles?: boolean;
  id: number;
  imageUrl: string;
  isProOnly: boolean;
  isSubscriberOnly: boolean;
  landingPageDescription: string;
  landingPageHeading: string;
  lang: string;
  name: string;
  offerCode?: string;
  order: number;
  previewDays: number;
  readLatestPath?: string;
}

export interface NewsletterSubscribeResponse {
  newsletter: Newsletter;
  current_user_subscribed: boolean;
}

export interface NewsletterSubscriptionsResponse {
  newsletterIds: number[];
}

export interface NewsletterDetailsParams {
  newsletter_ids?: number[];
}

export interface NewsletterDetailsResponse {
  newsletters: Newsletter[];
}

export async function getNewsletterSubscriptionStatus({
  newsletter_id,
}: NewsletterSubscriptionParams): Promise<NewsletterSubscriptionStatus> {
  const resp = await request('get', api_newsletter_subscription_status_path({ newsletter_id }));
  return resp;
}

export async function subscribeToNewsletter({
  newsletter_id,
}: NewsletterSubscriptionParams): Promise<NewsletterSubscribeResponse> {
  const resp = await request('post', api_newsletter_subscribe_path({ newsletter_id, ...getJWT() }));
  return resp;
}

export async function subscribeToAllNewsletters(): Promise<NewsletterSubscriptionsResponse> {
  const resp = await request('post', api_subscribe_to_all_newsletters_path({ ...getJWT() }));
  return resp;
}

export async function unsubscribeFromNewsletter({
  newsletter_id,
}: NewsletterSubscriptionParams): Promise<NewsletterSubscribeResponse> {
  const resp = await request(
    'post',
    api_newsletter_unsubscribe_path({ newsletter_id, ...getJWT() })
  );
  return resp;
}

export async function getNewsletterSubscriptions(): Promise<Newsletter[]> {
  const resp = await request('get', api_newsletters_path(getJWT()));
  return resp.newsletters.sort((n1: Newsletter, n2: Newsletter) => n2.order - n1.order);
}

export async function getNewsletterDetails({
  newsletter_ids,
}: NewsletterDetailsParams): Promise<NewsletterDetailsResponse> {
  const resp = await request('get', api_newsletter_details_path({ newsletter_ids }));
  return resp;
}
